import { Injectable } from '@angular/core';
import { ToastrService, ToastPackage } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  notify: Subject<boolean> = new Subject<boolean>();
  toastTimeout:any;

  constructor(private toastr: ToastrService, private router: Router,) { }

  showSuccess(message:any, title = 'Success', disableAutoClose = false): void {
    const successToaster = this.toastr.success(this.roleAlertTitleMessage(title, message, disableAutoClose), title);
    this.anchorTagAriaHiddenAndPlayPause(successToaster, disableAutoClose);
  }

  showError(message:any, title = 'Error', disableAutoClose = false): void {
    const successToaster = this.toastr.error(this.roleAlertTitleMessage(title, message, disableAutoClose), title);
    this.anchorTagAriaHiddenAndPlayPause(successToaster, disableAutoClose);
  }

  showInfo(message:any, title = 'Info', disableAutoClose = false): void {
    const successToaster = this.toastr.info(this.roleAlertTitleMessage(title, message, disableAutoClose), title);
    this.anchorTagAriaHiddenAndPlayPause(successToaster, disableAutoClose);
  }

  showWarning(message:any, title = 'Warning', disableAutoClose = false): void {
    const successToaster = this.toastr.warning(this.roleAlertTitleMessage(title, message, disableAutoClose), title);
    this.anchorTagAriaHiddenAndPlayPause(successToaster, disableAutoClose);
  }
  
  hide() {
    this.toastr.clear()
  }

  notifyLogin(event:any): void {
    this.notify.next(true);
  }

  roleAlertTitleMessage(title:any, message:any, disableAutoClose:any) {
    let playPause = ''
    if(!disableAutoClose) {
      playPause = `<div  class="ngx-toastr-play-pause"><i class="fa fa-pause play-pause-icon" aria-hidden="true"></i></div>`
    }
    return `<div class="ngx-toastr-title-with-message" tabindex="0" role="alert"><span>${title}</span> ${message} </div>` + playPause;
  }

  anchorTagAriaHiddenAndPlayPause(successToaster:any, disableAutoClose:any) {
    setTimeout(() => {
      const element:any = document.querySelector('.ngx-toastr-title-with-message')
      if(element) {
        element.querySelector('a').setAttribute('aria-hidden', 'true');
      }
    }, 100)

    setTimeout(() => {
      this.toastTimeout = setTimeout(() => {
        if(!disableAutoClose) {
          this.toastr.remove(successToaster.toastId)
        }
      }, 5000)

      if(!disableAutoClose) {
        const playPauseIcon:any = document.querySelector('.ngx-toastr-play-pause .play-pause-icon');
        if(playPauseIcon) {
          playPauseIcon.addEventListener('click', () => {
            if (playPauseIcon.classList.contains('fa-pause')) {
              clearTimeout(this.toastTimeout);
              playPauseIcon.classList.replace('fa-pause', 'fa-play');
            } else if (playPauseIcon.classList.contains('fa-play')) {
              this.toastTimeout = setTimeout(() => {
                this.toastr.remove(successToaster.toastId)
              }, 5000)
              playPauseIcon.classList.replace('fa-play', 'fa-pause');
            }
          })
        }
      }

      const updateBillingInformation:any = document.querySelector('.update-billing-information');
      if(updateBillingInformation) {
        updateBillingInformation.addEventListener('click', () => {
          this.router.navigate(['/checkout/billing'], { queryParams: { route: 'billing', isPaypalCheckout: false } });
          this.toastr.remove(successToaster.toastId)
        })
      }

      const updateShippingInformation:any = document.querySelector('.update-shipping-information');
      if(updateShippingInformation) {
        updateShippingInformation.addEventListener('click', () => {
          this.router.navigate(['/checkout/info-shipping'], { queryParams: { route: 'info-shipping' } });
          this.toastr.remove(successToaster.toastId)
        })
      }
    })
  }
}
